<div style=" display: inline;block-size: 10%;">

  <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;">

    <div class="col-md-6 pad0" style="display: inline-block; ">

      <h2 class="ng-binding header">
        Supplier Comparison
      </h2>
    </div>

    <div class="col-md-6 pad0" style="display: inline-block; padding-right: 0px;">
      <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; float: right; margin-top: 1.5%;" (click)="backBtn()">
        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
      </span>
      <span class="btn btn-yellow fntSz excelbtn" (click)="exportToExcel()" title="Export to Excel"
        style="cursor:pointer;margin-left: 10px;float: right;padding: 4px 10px;;margin-top: 2%;"><span><i
            class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
    </div>
  </div>
</div>

<!-- <div class="col-md-12 col-xs-12 col-sm-12"> -->

<div class="col-md-4 col-xs-4 col-sm-4 pad15 " style="display: inline-block; padding-top: 27px; padding-left: 21px">
  <!-- <input matInput placeholder="Select Category" (click)="selectCategory()" tabindex="1" [(ngModel)]="data.category"
    [matAutocomplete]="auto" class="autoselect">
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
      <span>{{x.cnm}} </span>
    </mat-option>
  </mat-autocomplete> -->

  <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 90%;"
    placeholder="Select Category">
    <option value="0" disabled="" selected="" hidden="">Select Category</option>
    <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
    <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
    <option id="select" value="4" class="ng-binding ng-scope">Food</option>
    <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
  </select>
</div>


<div class="col-md-4 col-xs-4 col-sm-4" style="display: inline-block;">

  <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 90%;"
    placeholder="Select Supplier">
    <option value="0" disabled="" selected="" hidden="">Select Supplier</option>
    <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
    <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
    <option id="select" value="4" class="ng-binding ng-scope">Food</option>
    <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
  </select>
  <!-- <input type="text" class="autoselect" placeholder="Prefered Supplier" aria-label="Number" matInput
    [matAutocomplete]="auto">
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{option}}
    </mat-option>
  </mat-autocomplete> -->
</div>

<div class="col-md-4 col-xs-4 col-sm-4 pad15" style="display: inline-block;">
  <!-- <label>Month:</label> -->

  <select required="" class="mrgnLeft10 form-control "
    style="width:135px;margin-left:0px;width:50%;display: inline-block;" placeholder="Select Category">

    <option value="0" disabled="" selected="" hidden="">Select Month</option>
    <option id="select" value="2" class="ng-binding ng-scope">June 2012</option>
    <option id="select" value="3" class="ng-binding ng-scope">May 2019</option>
    <option id="select" value="4" class="ng-binding ng-scope">Jan 2020</option>
    <option id="select" value="5" class="ng-binding ng-scope">June 2022</option>
  </select>

  <!-- <label>Month:</label>
  <input type="text" class="autoselect" aria-label="Number" matInput [matAutocomplete]="auto">
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{option}}
    </mat-option>
  </mat-autocomplete> -->
</div>
<!-- </div> -->

<div class="col-md-12 col-xs-12 col-sm-12 pad0" style="display: inline-block;padding-right: 0px; padding-top: 20px;">
  <div class="wrapper" style=" text-overflow: ellipsis;margin: 5px;">
    <table mat-table [dataSource]="dataSource" style="margin-top:20px">
      <ng-container matColumnDef="item">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Item</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.item}} </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> Category</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.category}} </td>
      </ng-container>

      <ng-container matColumnDef="preferredsupplier">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Preferred Supplier</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.preferredsupplier}} </td>
      </ng-container>

      <ng-container matColumnDef="cyberinfopvtltd">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Cyber Info Pvt Ltd</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.cyberinfopvtltd}} </td>
      </ng-container>

      <ng-container matColumnDef="acminerals">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> AC Minerals</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.acminerals}} </td>
      </ng-container>

      <ng-container matColumnDef="dpsupplier1">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>DP Supplier1</label>
        </th>
        <td><input type="text"></td>
        <td mat-cell *matCellDef="let element"> {{element.dpsupplier1}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <!-- Angular 8 pagination -->
    <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
    </mat-paginator>

  </div>
</div>